import useSWR, { SWRConfiguration } from 'swr';

import {
  Challenge,
  EventPlaylistChallenge,
  ChallengeSubmissionQueueItem,
  ChallengeSubmissionApprovalItem,
  EventPlaylistChallengeSubmissionListItem
} from '../../types/event';
import { GetAllAsync, GetAsync } from '../../services/api';
import { KendoGridResult } from '../../types/KendoGridResult';

const ChallengesEndpoint = 'challenges';

export const useGetChallenges = (options?: SWRConfiguration) => {
  const { data, error, isLoading } = useSWR<Challenge[]>(
    ChallengesEndpoint,
    GetAsync,
    options
  );

  if (error) console.log(error);

  return {
    challenges: data ?? [],
    isLoading,
    isError: error
  };
};

export const useGetEventPlaylistChallenges = (
  eventId: number | null | undefined,
  playlistId: number | null | undefined
) => {
  const key =
    eventId && playlistId
      ? `events/${eventId}/playlists/${playlistId}/challenges`
      : null;

  const { data, error, isLoading, mutate } = useSWR(key, (url) =>
    GetAsync<KendoGridResult<EventPlaylistChallenge>>(url)
  );

  return {
    challenges: data?.data ?? [],
    isLoadingChallenges: isLoading,
    challengesError: error,
    mutateChallenges: mutate
  };
};

export const useGetPlaylistChallengeSubmissions = (
  eventId: number | null | undefined,
  playlistId: number | null | undefined
) => {
  const key =
    eventId && playlistId
      ? `events/${eventId}/playlists/${playlistId}/submissions`
      : null;

  const { data, error, isLoading, mutate } = useSWR(key, (url) =>
    GetAsync<KendoGridResult<EventPlaylistChallengeSubmissionListItem>>(url)
  );

  return {
    submissions: data?.data ?? [],
    isLoadingSubmissions: isLoading,
    submissionsError: error,
    mutateSubmissions: mutate
  };
};

export const useGetPlaylistChallengeSubmissionsById = (
  eventId: string | null | undefined,
  playlistId: string | null | undefined,
  submissionId: string | null | undefined
) => {
  const key =
    eventId && playlistId && submissionId
      ? `events/${eventId}/playlists/${playlistId}/submissions/${submissionId}`
      : null;

  const { data, error, isLoading, mutate } = useSWR(key, (url) =>
    GetAsync<ChallengeSubmissionApprovalItem>(url)
  );

  return {
    data,
    isLoading,
    error,
    mutate
  };
};

export const useGetSubmissionsApprovalQueue = (
  params?: string,
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<
    KendoGridResult<ChallengeSubmissionQueueItem>
  >(
    'get-all-submission-approval',
    () => GetAllAsync(`admin/events/wst/submissions?${params}`),
    options
  );

  return { data, error, isLoading, mutate };
};
